import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

/**
 *  FEJLESZTŐI (nem publikus) felületek – ma a Jogszabályfigyelő.
 *
 *  A menüpont csak a fejlesztőknek jelenik meg (ez a lista csak a megjelenítést dönti el); a valódi
 *  döntés a kiszolgálóé: GET /api/jogszabalyfigyelo/jog (backend/jogszabalyfigyelo.js,
 *  JOGSZABALYFIGYELO_FELHASZNALOK). Ügyfél soha nem látja, és a szerepkör-szerkesztőben sem adható.
 */
export const FEJLESZTOK = ['blaha.peter'];

export function fejlesztoNev(nev: string | null | undefined): boolean {
  const n = String(nev || '').trim().toLowerCase();
  return !!n && (FEJLESZTOK.includes(n) || FEJLESZTOK.includes(n.split('@')[0]));
}

let gyorsitotar: Promise<boolean> | null = null;
/** A kiszolgáló szerint fejlesztő-e a bejelentkezett felhasználó (munkamenetenként egyszer kérdezzük). */
export function fejlesztoE(http: HttpClient): Promise<boolean> {
  gyorsitotar ||= firstValueFrom(http.get<{ fejleszto: boolean }>('/api/jogszabalyfigyelo/jog'))
    // Csak az igent jegyezzük meg: egy (pl. bejelentkezés előtti) „nem” ne ragadjon be.
    .then((v) => { if (!v?.fejleszto) gyorsitotar = null; return !!v?.fejleszto; })
    .catch(() => { gyorsitotar = null; return false; });
  return gyorsitotar;
}

export const fejlesztoGuard: CanActivateFn = async () => {
  const ok = await fejlesztoE(inject(HttpClient));
  return ok || inject(Router).parseUrl('/');
};
